<template>
<div>
    <AGISHeader :subMenuItems="[]"/>
    <div class="main-content" >
        <div :class="classList">
            <div class="container" >
                <main>
                    <router-view></router-view>
                    <p class="mt-3 mb-2 copy-right">&copy; Airport Authority Hong Kong. All Rights Reserved.</p>
                </main>
                <aside></aside>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import AGISHeader from '@/components/ui-components/AGISHeader';

export default {
  name: 'home-layout',
  components: {
      AGISHeader,
  },
  created: function () {
  },
  data:function(){
      return {
            classList: 'mask mark-hidden' 
      }
  },
  mounted:function() {
  },
}
</script>
<style>
html, body {
    width: 100%;
    height: 100%;
}

.content {
    min-height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
}
.mask {
    width:100%;
    height:100%;
}
.mark-hidden {
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Layout.vue